import Multiselect from "../../../../design-system/components/Multiselect/Multiselect.jsx";
import styles from "../showroomForm.css";

/**
 * Component representing a form multi-selection input.
 * Handles rendering a list of select-options with label, validation, and state management.
 *
 * @param {Object} props - The properties passed to the component.
 * @param {string} props.fieldKey - The key representing the field in the form data object.
 * @param {string} props.label - The label to be displayed for the selection input.
 * @param {string} props.description - The description to be displayed for the selection input.
 * @param {Object} props.formData - The form data object containing the state for all fields.
 * @param {Function} props.setFormData - Function to update the form data object.
 * @param {Array} props.options - The options to display within the selection dropdown.
 * @param {boolean} props.required - Indicates whether the selection is mandatory.
 * @param {Function} props.validate - Function to validate the input value.
 * @param {string | null} props.error - An error message to display if validation fails.
 * @returns {JSX.Element} Returns a dropdown selection component.
 */
export const MultiSelection = ({
  fieldKey,
  label,
  description,
  formData,
  setFormData,
  options,
  required,
  validate,
  error,
  edit = false,
}) => {
  return (
    <div className={styles.formGroup}>
      {label && (
        <h2>
          {label}
          {required && "*"}
        </h2>
      )}
      {description && <p className={styles.description}>{description}</p>}
      <Multiselect
        name={fieldKey}
        selected={
          edit ? (formData[fieldKey].data ?? "") : (formData[fieldKey] ?? "")
        }
        onChange={(e) => {
          const selectedValues = Array.from(e.target.selectedOptions).map(
            (opt) => opt.value,
          );
          validate(e.target.name, selectedValues);
          setFormData((prevFormData) => ({
            ...prevFormData,
            [fieldKey]: selectedValues,
          }));
        }}
        options={options}
        required={required}
        error={error}
      />
    </div>
  );
};
